export default "__VITE_ASSET__DYA9epwF__"